import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Text } from '@digsup/components-text';

import { styles } from './PolaroidCardTitle.scss';

const cx = classNames.bind(styles);

export const PolaroidCardTitle = ({
  fontFamily,
  className,
  children,
  ...props
}) => {
  const classes = cx(
    'c-pollaroid-card-title',
    {
      [`c-pollaroid-card-title--${fontFamily}`]: fontFamily,
    },
    className,
  );

  return (
    <Text
      size="3xs"
      align="center"
      fontWeight={fontFamily === 'serif' ? 'semibold' : 'regular'}
      ellipsis
      className={classes}
      {...props}>
      {children}
    </Text>
  );
};

PolaroidCardTitle.propTypes = {
  fontFamily: PropTypes.oneOf(['cursive', 'serif']),
  className: PropTypes.string,
  children: PropTypes.any,
};

PolaroidCardTitle.defaultProps = {
  fontFamily: 'cursive',
  className: '',
};
